import Layout from './containers/Layout'
import './App.css'

function App() {
    return <Layout />
}

export default App
